<div class="chart-container card flex space-around">
    <p-chart #chart type="bar" [data]="results" class="w-half md:w-[60rem]" [options]="typesOptions"></p-chart>
    <p-chart #locChart type="bar" [data]="locResults" class="w-half md:w-[60rem]" [options]="locOptions"></p-chart>
    <div class="slice-container card flex justify-content-center">    
        <div class="scope-container card flex justify-content-center">
            <label for="slice">Scope</label>
            <p-selectButton 
            [disabled]="showDetail"
            [options]="scopeOptions" 
            [(ngModel)]="scopeValue" 
            optionLabel="label" 
            (onOptionClick)="onScopeChange($event)"
            multiple="true"
            optionValue="value" 
            class="custom-select-button"/>
        </div>
        <div class="phase-container card flex justify-content-center">
            <label for="slice">Phase</label>
            <p-selectButton 
            [disabled]="showDetail"
            [options]="phaseOptions" 
            [(ngModel)]="phaseValue" 
            (onOptionClick)="onPhaseChange($event)"
            multiple="true"
            optionLabel="label" 
            optionValue="value" />
        </div> 
    </div>
    <p-tabView [ngStyle]="{width: '100%'}" class="centered-tabview">
        <p-tabPanel header="Inventory">
            <p-treeTable id="inventory" [value]="inventoryTreeTableResults" *ngIf="!showDetail">
                <ng-template pTemplate="header">
                    <tr>
                        <th *ngFor="let col of inventoryColumns" [ngStyle]="{'width': col.width + 'px'}" [ngClass]="{
                            'align-right': col.align === 'right'
                        }">
                            {{ col.label }}
                        </th>
                    </tr>
                </ng-template>
                <ng-template pTemplate="body" let-rowNode let-rowData="rowData">
                    <tr [ttRow]="rowNode">
                        <td *ngFor="let col of inventoryColumns; let index = index" [ngStyle]="{'max-width': col.width + 'px'}"
                        [ngClass]="{'object-attribute': col.field === 'attribute' && rowNode.parent !== null,
                            'object-type': col.field === 'object_type' && rowNode.parent !== null,
                            'align-right': col.align === 'right'
                         }"
                        (click)="showDetailedTable(col.field, rowNode)">
                            <p-treeTableToggler [rowNode]="rowNode"*ngIf="index == 0"></p-treeTableToggler>
                            <ng-container *ngIf="isNumber(rowData[col.field]); else notNumber">
                                {{ rowData[col.field] | number }}
                            </ng-container>
                            <ng-template #notNumber>
                                {{ rowData[col.field] == 0 ? "" : rowData[col.field] }}
                            </ng-template>
                        </td>
                    </tr>
                </ng-template>
            </p-treeTable>
            <button pButton id="backButton" *ngIf="showDetail" (click)="backToSummary()">Back to Summary</button>
            <app-detail-table [data]="detailTableData" *ngIf="showDetail" ></app-detail-table>
        </p-tabPanel>
        <p-tabPanel header="Copybooks">
            <p-treeTable #dt [value]="treeTableResults" [paginator]="true" [rows]="10" [scrollable]="true">
                <ng-template pTemplate="header">
                    <tr>
                        <th *ngFor="let col of columns" [ngStyle]="{'width': col.width + 'px'}" [ngClass]="{
                            'align-right': col.align === 'right'
                        }">
                            {{ col.label }}
                        </th>
                    </tr>
                </ng-template>
                <ng-template pTemplate="body" let-rowNode let-rowData="rowData">
                    <tr [ttRow]="rowNode">
                        <td *ngFor="let col of columns; let index = index" [ngStyle]="{'width': col.width + 'px'}" 
                        [ngClass]="{'align-right': col.align === 'right'}">
                            <p-treeTableToggler [rowNode]="rowNode" *ngIf="index == 0"></p-treeTableToggler>
                            <ng-container *ngIf="isNumber(rowData[col.field]); else notNumber">
                                {{ rowData[col.field] | number }}
                            </ng-container>
                            <ng-template #notNumber>
                                {{ rowData[col.field] == 0 ? "" : rowData[col.field] }}
                            </ng-template>
                        </td>
                    </tr>
                </ng-template>
            </p-treeTable>
        </p-tabPanel>
    </p-tabView>
</div>